export const DEFAULT_SOLUTION_PROCESSING_ACTIVITY = {
  nom: "HAPIVOT RGPD suite",
  finalite: "Autre",
  baseLegale: "Contrat (art. 6(1)(b))",
  description:
    "Application de pilotage de la conformité RGPD : gestion du registre des traitements (ROPA), des preuves de conformité, des consentements, des demandes de droits, des incidents, des sous-traitants et de la gouvernance (RACI).",
  categoriesDonnees: ["Identité", "Coordonnées"],
  categoriesPersonnes: ["Clients", "Prospects"],
  originesDonnees: "Données collectées via la solution",
  destinataires: ["Services internes"],
  destinatairesDetail: "Équipes internes en charge de l'exploitation de la solution.",
  transfertsHorsUE: false,
  transfertsDetail: "",
  dureeConservation: "1-3 ans",
  dureeDetail: "Selon les besoins opérationnels de la solution.",
  mesuresSecurite: ["Contrôle d'accès", "Chiffrement"],
  mesuresDetail: "Accès restreint par rôle et chiffrement des données en transit.",
  responsableId: "",
  sousTraitantsConcernes: "",
  risque: "Modéré",
  piaRealise: false,
  observations:
    "Traitement par défaut décrivant l'application HAPIVOT RGPD suite. Ces informations sont modifiables dans la configuration.",
};
